/*
 Utilities to be used working with CSS Modules
 */

import _ from 'lodash';

export default {
  /**
   * Applies hashed CSS Module styles
   * to the provided template
   * using the Lodash template engine
   *
   * @param {String} template
   * @param {Object} hashedStyles
   * @returns {String}
   */
  hashTemplate: function hashTemplate(template, hashedStyles) {
    return _.template(template)(hashedStyles);
  }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-js/CssUtil.js
// module id = 3
// module chunks = 0